import { useEffect } from 'react';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { useNavigate } from 'react-router-dom';

export const useEnsureAuthenticated = () => {
  const push = useNavigate();
  const session = useCurrentUser();

  useEffect(() => {
    if (session.state.isInitialized && !session.state.account) {
      push('/login');
    }
  }, [push, session.state.account, session.state.isInitialized]);
};
